import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { FDHeadlineText } from '@facet-wealth/design';
import ModelInputSection
  from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadHistoryPicker/ModelInputSection';
import ExternalSystemLinkSection
  from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadHistoryPicker/ExternalSystemLinkSection';
import RoutingHistorySection
  from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadHistoryPicker/RoutingHistorySection';

export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'sm',
    },
  }, { ordinal: 200 })
  .nameOverride('modelOutput', {
    _component: () => ModelInputSection,
  }, { ordinal: 200 })
  .nameOverride('routingHistoryItems', {
    _component: () => RoutingHistorySection,
  }, { ordinal: 200 })
  .nameOverride('externalSystemLink', {
    _component: () => ExternalSystemLinkSection,
  }, { ordinal: 200 });
